export default __webpack_public_path__ + "static/media/CSRealCase2.ea29ea43.jpg";